<template>
  <div>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-input size="medium" v-model="searchForm.brand"></el-input>
          </el-form-item>
          <el-form-item label="规格：">
            <el-input size="medium" v-model="searchForm.specification"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="searchTable()">筛选</el-button>
            <el-button size="medium" @click="addNewSku()">添加SKU</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="INNER_CODE" label="编号" min-width="100"></el-table-column>
          <el-table-column prop="NAME" label="名称" min-width="130"></el-table-column>
          <el-table-column prop="DECLARE_NAME" label="备货方案" min-width="130"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="text" v-show="scope.row.USING_ID > 0">在用SKU</el-tag>
              <el-tag type="text" v-show="scope.row.USING_ID == 0">非在用SKU</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-edit" @click="matchData(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
          :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 匹配在用SKU -->
    <el-dialog title="新增在用SKU" center :visible.sync="addFormVisible" width="700px" :close-on-click-modal="false">
      <el-row>
        <el-form :model="addForm" ref="addForm" size="small" class="el-form--label-justify">
          <el-col :span="12">
            <el-form-item label="产品分类：" :label-width="formLabelWidth">
              <el-select v-model="addForm.CATALOG_ID" style="width:80%" filterable>
                <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="体积：" :label-width="formLabelWidth">
              <el-input v-model="addForm.VOLUME" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="温区：" :label-width="formLabelWidth">
              <label slot="label">温&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：</label>
              <el-select v-model="addForm.WZ_TYPE_ID" style="width:80%">
                <el-option v-for="item in WZ_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库方式：" :label-width="formLabelWidth">
              <el-select v-model="addForm.OW_TYPE" style="width:80%">
                <el-option v-for="item in wayOut" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安全库存：" :label-width="formLabelWidth">
              <el-input v-model="addForm.SAFETY_STOCK" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="销项税率：" :label-width="formLabelWidth">
              <el-input v-model="addForm.OUTPUT_VAT" style="width:70%"></el-input> <span>%</span>
            </el-form-item>
            <el-form-item label="团餐公司：" :label-width="formLabelWidth" v-if="fun_dic[100250101]">
              <el-select filterable v-model="addForm.tc_name" multiple collapse-tags placeholder="请选择" style="width:80%">
                <el-option v-for="item in tcName" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产企业：" :label-width="formLabelWidth">
              <el-select filterable v-model="addForm.SOURCE_COMPANY_ID" placeholder="请选择" style="width:80%">
                <el-option v-for="item in 生产企业列表" :key="item.SOURCE_ID" :label="item.SOURCE_COMPANY" :value="item.SOURCE_ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量：" :label-width="formLabelWidth">
              <el-input v-model="addForm.WEIGHT" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="预警期：" :label-width="formLabelWidth">
              <label slot="label">预&nbsp;&nbsp;警&nbsp;&nbsp;期：</label>
              <el-input v-model="addForm.WARNING_PERIOD" style="width:50%"></el-input>
              <el-select v-model="addForm.WP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保质期：" :label-width="formLabelWidth">
              <label slot="label">保&nbsp;&nbsp;质&nbsp;&nbsp;期：</label>
              <el-input v-model="addForm.QGP" style="width:50%"></el-input>
              <el-select v-model="addForm.QGP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下架期：" :label-width="formLabelWidth">
              <label slot="label">下&nbsp;&nbsp;架&nbsp;&nbsp;期：</label>
              <el-input v-model="addForm.PULL_OFF_PERIOD" style="width:50%"></el-input>
              <el-select v-model="addForm.PO_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="进项税率：" :label-width="formLabelWidth">
              <el-input v-model="addForm.INPUT_VAT" style="width:70%"></el-input> <span>%</span>
            </el-form-item>
            <el-form-item label="库位编码：" :label-width="formLabelWidth">
              <el-select v-model="addForm.LOCATION_CODE" style="width:80%">
                <el-option v-for="item in positionLi" :key="item.ID" :label="item.CODE" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报货方案：" :label-width="formLabelWidth">
              <el-select v-model="addForm.DECLARE_TYPE_ID" style="width:80%" clearable>
                <el-option v-for="item in PlanList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" center class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAdd('addForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增SKU -->
    <el-dialog title="新增SKU" center :visible.sync="addSKUFormVisible" width="450px">
      <el-form :model="addSKUForm" ref="addSKUForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-input v-model="addSKUForm.NAME" @input="handleInputChange" type="text"></el-input>
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          <!--          <el-input v-model.trim="addSKUForm.TYPE_UNIT"></el-input>-->
          <el-select v-model="addSKUForm.TYPE_UNIT" style="width: 280px" placeholder="请选择" clearable filterable>
            <el-option v-for="item in TYPE_UNIT_LIST" :key="item.KD_CODE + '/' + item.UNIT_ID" :label="item.TYPE_UNIT"
              :value="item.KD_CODE + '/' + item.UNIT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：" :label-width="formLabelWidth">
          <el-input v-model.trim="addSKUForm.BRAND"></el-input>
        </el-form-item>
        <el-form-item label="规格：" :label-width="formLabelWidth">
          <el-input v-model.trim="addSKUForm.SPECIFICATION"></el-input>
        </el-form-item>
        <el-form-item label="一级大类：" :label-width="formLabelWidth">
          <el-select filterable v-model="addSKUForm.FIRST_TYPE" style="width: 100%" @change="getSecond()">
            <el-option v-for="item in firstLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级大类：" :label-width="formLabelWidth">
          <el-select filterable v-model="addSKUForm.SECOND_TYPE" style="width: 100%">
            <el-option v-for="item in secondLists" :key="item.INNER_CODE" :value="item.INNER_CODE" :label="item.NAME">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库方式：" :label-width="formLabelWidth">
          <el-select filterable v-model="addSKUForm.OW_TYPE" style="width: 100%">
            <el-option v-for="item in wayOut" :key="item.ID" :value="item.ID" :label="item.NAME"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自有分类：" :label-width="formLabelWidth">
          <el-select v-model="addSKUForm.CATALOG_ID" style="width:100%" filterable>
            <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报货方案：" :label-width="formLabelWidth">
          <el-select v-model="addSKUForm.DECLARE_TYPE_ID" style="width:100%" filterable>
            <el-option v-for="item in PlanList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitAddSKU">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import {
  queryWQ, noMatchSKU, addUseSKU, getClassFun, addNewSKUFun, getLKDFirstKindFun, getLKDSecondKindFun,
} from '@/assets/api/skuManage';
import { queryPosition } from '@/assets/api/warehouseManager';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      PAGE_ID: '1002501', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100250101: 0 },
      addForm: {
        WZ_TYPE_ID: 0,
        OUTPUT_VAT: 0,
        OW_TYPE: 0,
        WARNING_PERIOD: 0,
        INPUT_VAT: 0,
        PlanList: [],
        QGP: 0,
        PULL_OFF_PERIOD: 0,
        QGP_TIME_TYPE: 1,
        PO_TIME_TYPE: 1,
        WP_TIME_TYPE: 1,
        LOCATION_CODE: 0,
        SAFETY_STOCK: 0,
        VOLUME: 0,
        WEIGHT: 0,
        tc_name: [],
        DECLARE_TYPE_ID: '',
        SOURCE_COMPANY_ID: 0,
      },
      tcName: [],
      PlanList: [],
      TYPE_UNIT_LIST: [],
      ADD_TYPE_UNIT: '',
      date_list: [
        {
          ID: 1,
          NAME: '年',
        }, {
          ID: 2,
          NAME: '季',
        }, {
          ID: 3,
          NAME: '月',
        }, {
          ID: 4,
          NAME: '日',
        }, {
          ID: 5,
          NAME: '时',
        },
      ], // 时间类型
      WZ_list: [], // 温区
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      updateVisible: false,
      loading: false,
      searchForm: {},
      addFormVisible: false,
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      productCode: '',
      formLabelWidth: '120px',
      positionLi: [],
      catalogNum: sessionStorage.getItem('catalogNum'),
      catalogList: [],
      secondCatalogList: [],
      thirdCatalogList: [],
      forthCatalogList: [],
      addSKUFormVisible: false,
      addSKUForm: {
        NAME: '',
      },
      firstLists: [],
      secondLists: [],
      生产企业列表: [],
    };
  },
  created() {
    this.queryPurchasePlan(); // 拉取报货方案
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于sessionStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryCatalog();
    this.queryFirstCatalog();
    this.queryTCName();
    this.queryBeforeFun();
    this.queryUnit();
    this.拉取生产企业();
    queryPosition()
      .then((res) => {
        this.positionLi = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
  },
  methods: {
    拉取生产企业() {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 52,
        COMPANY_ID: Number(sessionStorage.getItem('tcId')),
      };

      http.post(params).then((res) => {
        this.生产企业列表 = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 空格自动删除
    handleInputChange() {
      this.$nextTick(() => {
        if (/\s/.test(this.addSKUForm.NAME)) {
          this.addSKUForm.NAME = this.addSKUForm.NAME.replace(/\s/g, '');
        }
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 拉取 报货方案
    queryPurchasePlan() {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 13,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result[0].OP_ROLE.length !== 0) {
          this.PlanList = result[0].OP_ROLE;
        } else {
          this.PlanList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 获取团餐公司信息列表
    queryTCName() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 26,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        if (result) {
          this.tcName = result;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryUnit() {
      const params = {
        SERVICE_ID: '60001',
        OTYPE: 1,
        PAGE_INDEX: 0,
        PAGE_SIZE: 100000,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.TYPE_UNIT_LIST = result[0].UNIT_DATA;
          this.totalNum = result[0].TOTAL_COUNT;
        } else {
          this.TYPE_UNIT_LIST = [];
          this.totalNum = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        // SHORT_NAME: this.searchForm.name,
      };
      if (this.searchForm.brand) {
        params.BRAND = this.searchForm.brand;
      } else {
        params.BRAND = '';
      }
      if (this.searchForm.specification) {
        params.SPECIFICATION = this.searchForm.specification;
      } else {
        params.SPECIFICATION = '';
      }
      // if (!this.searchForm.name) {
      //   this.$message.show({ text: '请输入产品名称', type: 'warning' });
      //   return false;
      // }
      if (this.searchForm.name && this.searchForm.name != '') {
        params.SHORT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code && this.searchForm.code != '') {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      noMatchSKU(params)
        .then((result) => {
          if (result.length) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL;
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
            this.totalCount = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    matchData(row) {
      this.queryWZ();
      this.productCode = row.INNER_CODE;
      this.addForm = { ...this.addForm, ...row };
      this.addFormVisible = true;
    },
    close() {
      this.addFormVisible = false;
      this.addSKUFormVisible = false;
    },
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            PRODUCT_CODE: this.productCode,
            ALIAS_NAME: this.addForm.NAME,
            GYS_ID: sessionStorage.getItem('tcId'),
            CATALOG_ID: this.addForm.CATALOG_ID,
            SAFETY_STOCK: this.addForm.SAFETY_STOCK,
            WZ_TYPE_ID: this.addForm.WZ_TYPE_ID ? this.addForm.WZ_TYPE_ID : 0,
            OW_TYPE: this.addForm.OW_TYPE ? this.addForm.OW_TYPE : 0,
            QGP: Number(this.addForm.QGP) ? Number(this.addForm.QGP) : 0,
            QGP_TIME_TYPE: this.addForm.QGP_TIME_TYPE ? this.addForm.QGP_TIME_TYPE : 1,
            WARNING_PERIOD: Number(this.addForm.WARNING_PERIOD) ? Number(this.addForm.WARNING_PERIOD) : 0,
            WP_TIME_TYPE: this.addForm.WP_TIME_TYPE ? this.addForm.WP_TIME_TYPE : 1,
            PULL_OFF_PERIOD: Number(this.addForm.PULL_OFF_PERIOD) ? Number(this.addForm.PULL_OFF_PERIOD) : 0,
            PO_TIME_TYPE: this.addForm.PO_TIME_TYPE ? this.addForm.PO_TIME_TYPE : 1,
            INPUT_VAT: Number(this.addForm.INPUT_VAT) ? Number(this.addForm.INPUT_VAT) : 0,
            OUTPUT_VAT: Number(this.addForm.OUTPUT_VAT) ? Number(this.addForm.OUTPUT_VAT) : 0,
            DEFAULT_LOCATION_ID: Number(this.addForm.LOCATION_CODE) ? Number(this.addForm.LOCATION_CODE) : 0,
            VOLUME: Number(this.addForm.VOLUME) ? Number(this.addForm.VOLUME) : 0,
            WEIGHT: Number(this.addForm.WEIGHT) ? Number(this.addForm.WEIGHT) : 0,
            DECLARE_TYPE_ID: this.addForm.DECLARE_TYPE_ID ? this.addForm.DECLARE_TYPE_ID : 0,
            SOURCE_COMPANY_ID: this.addForm.SOURCE_COMPANY_ID ? this.addForm.SOURCE_COMPANY_ID : 0,
          };
          if (this.addForm.CATALOG_ID) {
            params.THIRD_CATALOG_ID = this.addForm.CATALOG_ID;
          }
          if (this.addForm.tc_name.length != 0) {
            params.TC_ID = this.addForm.tc_name;
          }
          addUseSKU(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.queryTable();
            this.addFormVisible = false;
            this.addForm = {
              WZ_TYPE_ID: 0,
              OUTPUT_VAT: 0,
              OW_TYPE: 0,
              WARNING_PERIOD: 0,
              INPUT_VAT: 0,
              QGP: 0,
              PULL_OFF_PERIOD: 0,
              QGP_TIME_TYPE: 1,
              PO_TIME_TYPE: 1,
              WP_TIME_TYPE: 1,
              LOCATION_CODE: 0,
              SAFETY_STOCK: 0,
              VOLUME: 0,
              WEIGHT: 0,
              tc_name: [],
            };
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    // 分页
    handleCurrentChange() {
    },
    searchTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 拉取温区
    queryWZ() {
      queryWQ().then((result) => {
        this.WZ_list = result;
      }).catch((error) => {
      });
    },
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addNewSku() {
      this.addSKUFormVisible = true;
    },
    // 获取LKD系统一级二级大类
    queryFirstCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
      };
      getLKDFirstKindFun(param).then((result) => {
        this.firstLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySecondCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
        FIRST_CATALOG_CODE: this.addSKUForm.FIRST_TYPE,
      };
      getLKDSecondKindFun(param).then((result) => {
        this.secondLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getSecond() {
      this.querySecondCatalog();
    },
    // 新增SKU
    submitAddSKU() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const strlist = this.addSKUForm.TYPE_UNIT.split('/');
          this.TYPE_UNIT_LIST.map((item) => {
            if (item.UNIT_ID == strlist[1]) {
              this.ADD_TYPE_UNIT = item.TYPE_UNIT;
            }
          });
          const params = {
            SHORT_NAME: this.addSKUForm.NAME,
            CATALOG_ID: this.addSKUForm.CATALOG_ID,
            OW_TYPE: this.addSKUForm.OW_TYPE,
            TYPE_UNIT: this.ADD_TYPE_UNIT,
            UNIT_ID: strlist[1],
            KD_CODE: strlist[0],
            SECOND_CATALOG_CODE: this.addSKUForm.SECOND_TYPE,
          };
          if (this.addSKUForm.SPECIFICATION) {
            params.SPECIFICATION = this.addSKUForm.SPECIFICATION;
          } else {
            params.SPECIFICATION = '';
          }
          if (this.addSKUForm.BRAND) {
            params.BRAND = this.addSKUForm.BRAND;
          } else {
            params.BRAND = '';
          }
          if (this.addSKUForm.DECLARE_TYPE_ID) {
            params.DECLARE_TYPE_ID = this.addSKUForm.DECLARE_TYPE_ID;
          }
          if (!this.addSKUForm.NAME || !this.addSKUForm.TYPE_UNIT || !this.addSKUForm.FIRST_TYPE || !this.addSKUForm.SECOND_TYPE || !this.addSKUForm.OW_TYPE) {
            this.$message.show({ text: '请输入产品名称、单位、一级大类、二级大类和出库方式', type: 'warning' });
            return false;
          }

          addNewSKUFun(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addSKUFormVisible = false;
            this.addSKUForm = {};
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    handleChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/matchSku.vue